export default __webpack_public_path__ + "static/media/arr2.a18a818d.svg";